export const engagementReportBuilder2AppGroupIdReportIdRun =
  "/engagement/report_builder_2/:report_id/:app_group_id/run";
